import simg1 from "../images/services/icon-1.svg";
import simg2 from "../images/services/icon-2.svg";
import simg3 from "../images/services/icon-3.svg";
import simg4 from "../images/services/icon-4.svg";

import sSimg1 from "../images/service-single/1.webp";
import sSimg2 from "../images/service-single/2.webp";
import sSimg3 from "../images/service-single/3.webp";
import sSimg4 from "../images/service-single/4.webp";

const SummitObjectives = [
  {
    Id: "01",
    sImg: simg1,
    sSImg: sSimg1,
    title: "Master Cash Flow Secrets",
    slug: "1",
    description:
      "Discover time-tested systems to take control of money, plug financial leaks, and ensure bulletproof growth strategies that work in every economy.",
  },
  {
    Id: "02",
    sImg: simg2,
    sSImg: sSimg2,
    title: "Use Smart Wealth Tools",
    slug: "2",
    description:
      "Gain access to cutting-edge tech and financial hacks built specifically for business owners. Automate, optimize, and accelerate your cash cycles.",
  },
  {
    Id: "03",
    sImg: simg3,
    sSImg: sSimg3,
    title: "Unlock Financial Freedom",
    slug: "3",
    description:
      "Build profit stability that goes beyond numbers, empowering you to achieve real financial independence and peace of mind.",
  },
  {
    Id: "04",
    sImg: simg4,
    sSImg: sSimg4,
    title: "Be Part of a Global Movement",
    slug: "4",
    description:
      "Network with entrepreneurs from 21+ countries and 100+ cities, sharing wisdom, opportunities, and vision in a truly global entrepreneurial revolution.",
  },
];

export default SummitObjectives;
